(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Page BUilder
//
// ------------------------------------

(function ($) {

    if (typeof window.TheChurchCo_PageBuilder == 'undefined') window.TheChurchCo_PageBuilder = {};

    TheChurchCo_PageBuilder = {

        // Block Definitions
        blockDefinitions: {
            rows_basic_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/paper.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-basic.jpg',
                title: 'Basic Text',
                description: 'Title Text & Button. The basics of every block.',
            },
            rows_service_times_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/clock.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-times.jpg',
                title: 'Times',
                description: 'Add your times and location',
            },
            // rows_ministries_row: {
            //     icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/church.png',
            //     title: 'Ministries',
            //     description: 'List your ministry pages.',
            // },
            rows_team_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/people.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-team.jpg',
                title: 'Team',
                description: 'List your staff or team.',
            },
            rows_imageblocktwo_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/image.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-images.jpg',
                title: 'Images 2.0',
                description: 'Add multiple images to a page.',
            },
            rows_image_columns_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/image.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-images.jpg',
                title: 'Images (old)',
                description: 'Add multiple images to the page.',
            },
            rows_icon_columns_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/018.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-icons.jpg',
                title: 'Icon List',
                description: 'List text with icons.',
            },
            rows_text_columns_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/text.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-long-text.jpg',
                title: 'Long Text',
                description: 'Add extended text across multiple columns.',
            },
            rows_blog_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/paper.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-blog.jpg',
                title: 'Blog List',
                description: 'List and feature your latest blog posts',
            },
            rows_podcast_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/mic.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-podcast.jpg',
                title: 'Podcasts',
                description: 'List and feature your latest podcasts or sermons',
            },
            rows_video_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/play.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-video.jpg',
                title: 'Video Embed',
                description: 'Add Video to the page',
            },
            rows_events_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/date.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-events.jpg',
                title: 'Event List',
                description: 'List and feature upcoming events.',
            },
            rows_form_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/forms.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-form.jpg',
                title: 'Form',
                description: 'Add a form to the page.',
            },
            rows_quote_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/text-center.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-quote.jpg',
                title: 'Quote',
                description: 'Feature a quote in large text.',
            },
            rows_groups_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/people-group.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-groups.jpg',
                title: 'Groups Engine',
                description: 'Include the Groups Engine on a page.',
            },
            rows_social_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/instagram.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-social.jpg',
                title: 'Instagram Feed',
                description: 'Include feeds from your social media accounts.',
            },
            rows_giving_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/dollar.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-giving.jpg',
                title: 'Giving Form',
                description: 'Include a donation form on the page.',
            },
            rows_prayer_request_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/079.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-prayer.jpg',
                title: 'Prayer Requests',
                description: 'Add the prayer wall to your page.',
            },
            rows_accordion_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/accordion.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-accordion.jpg',
                title: 'Accordions',
                description: 'Add an accordion to your page.',
            },
            rows_subnav_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/menus.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-subnav.jpg',
                title: 'Subnav',
                description: 'Add subnavigation to your page.',
            },
            rows_htmlembed_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/code.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-html.jpg',
                title: 'HTML Embed',
                description: 'Add HTML or Embed Code to your page.',
            },
            rows_rssblock_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/041.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-rssblock.jpg',
                title: 'RSS Feed',
                description: 'Read your data onto this webpage from an RSS Feed.',
            },
            rows_churchonline_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/book-open.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-churchonline.jpg',
                title: 'Church Online',
                description: 'An Application to host church online.',
            },
            rows_photogallery_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/photogallery.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-photogallery.jpg',
                title: 'Photo Gallery',
                description: 'Display multiple images in a gallery.',
            },
            rows_marqueeblock_row: {
                icon: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/icons/marqueeblock.png',
                layout: 'https://v1staticassets.thechurchco.com/content/plugins/thechurchco/inc/admin/assets/page-builder/block-marquee.jpg',
                title: 'Marquee',
                description: 'Add animated marquee.',
            }
        },

        acfBlocks: {},

        // ------------------------------------
        // Init
        // ------------------------------------

        init: function () {


            this.acfMainButton = $('.acf-actions a[data-event="add-layout"]');
            if (!this.acfMainButton.length) return;

            // Close Boxes by Default
            $('.postbox').addClass('closed'); //.not('#submitdiv') for not publis
            $('.acf-flexible-content .layout').addClass('-collapsed');

            // Modify Block
            this.modifyBlocks();

            // Grab ACF Options
            this.acfFlexibleMarkup = $('.tmpl-popup').html();
            this.body = $('body');
            this.acfDropzone = $('.acf-flexible-content');

            // Collect Available Blocks
            this.blocks = this.getBlocks();


            // Create Trigger
            this.createTrigger();

            // Create Modal
            this.createModal();

        },

        modifyBlocks() {

            //$('.acf-flexible-content .layout')
            // TODO: Foreach Layout
            // - Add the title to the header
            // - Fade out if unpusblich
            $('.acf-flexible-content').find("[data-layout]:not('.acf-clone')").each(function (index) {
                const $layout = $(this);
                const $blockTitle = $layout.find('.thechurchco-block-title');
                const $rowTitle = $layout.find('[data-name*="_row_title"]').find('input').val();
                if ($rowTitle) $blockTitle.text($rowTitle);

                // Published
                const $rowStatus = $layout.find('[data-name="rows_status"]').find('select').val();
                if ($rowStatus == 'unpublished') $layout.addClass('-tcc-unpublished')
            })
            // $('.acf-flexible-content .values').each(function(layout){
            //     console.log(layout,"L")
            //     const $layout = $(this);
            //     console.log($layout,"$L")
            // })

        },

        createTrigger() {

            // Blue Plus
            let triggerMarkup = `<a href="#" class="page-builder-trigger"><span class="icon icon-plus-circled"></span></a>`;
            this.trigger = $(triggerMarkup);
            this.trigger.on('click', TheChurchCo_PageBuilder.toggle);

            // New ACF Like Button
            let acfFakeButton = `<li><a href="#" class="acf-button button button-primary acf-button-fake">New Page Builder Block</a></li>`;
            this.acfFakeButton = $(acfFakeButton);
            $('.acf-flexible-content > .acf-actions').append(this.acfFakeButton);
            this.acfFakeButton.on('click', TheChurchCo_PageBuilder.toggle);

            // Add To Body
            this.body.append(this.trigger);
        },

        createModal() {

            let modalMarkup = `<div class="page-builder-blocks">
                <div class="page-builder-content">
                    <div class="page-builder-heading">
                        <h1>Page Builder</h1>
                        <p>Choose a block to add it to the page. Click save to see it on the page.</p>
                    </div>

                    <div class="page-builder-block-list">${this.renderBlocks()}</div>
                </div>
            </div>`;

            this.modal = $(modalMarkup);

            // Add To Body
            this.body.append(this.modal);

            // Attach Click Events
            this.modal.find('a').on('click', this.insertBlock);


        },

        insertBlock(e) {


            let $block = $(this);
            let type = $block.data('layout');

            if (!type) { e.preventDefault(); return; } // Unavailable Blocks


            // Open The Page Builder Button
            TheChurchCo_PageBuilder.acfMainButton.trigger('click');

            // Get The ACF Option
            let $acfOption = $('.acf-fc-popup [data-layout="' + type + '"]');

            // Click The Button
            $acfOption.trigger('click');

            // Close ACF Button
            $('.acf-fc-popup .focus').blur();

            // Scroll & Focus
            let $newBlock = $('.acf-flexible-content .layout:last-child').not('.acf-clone');

            // Open New Block
            $newBlock.removeClass('-collapsed');

            $([document.documentElement, document.body]).animate({
                scrollTop: ($newBlock.offset().top - 100)
            }, 500);



            // Close Modal
            // TheChurchCo_PageBuilder.trigger.trigger('click'); // Click to also close acfMainButton

            TheChurchCo_PageBuilder.toggle();


        },

        getBlocks() {

            let blocks = [];

            $(this.acfFlexibleMarkup).find('a').each(function (index) {

                let $item = $(this);
                let clean = {};
                clean.title = $item.text();
                if (!clean.title) return;
                clean.rowId = $item.data('layout');
                blocks.push(clean);

                TheChurchCo_PageBuilder.acfBlocks[clean.rowId] = clean;


            })

            return blocks;

        },

        renderBlocks() {

            // Let's Reverse it and go through our definitions.
            let blocks = ``;
            let leftOverBlocks = Object.keys(this.blockDefinitions).filter(key => {

                // Render Available Block
                if (this.acfBlocks[key]) {
                    let item = this.renderBlock(this.acfBlocks[key])
                    if (item) blocks += item
                } else {
                    return key;
                }

            })

            // Render Unavailable Blocks
            leftOverBlocks.map(key => {
                let item = this.renderBlock(this.blockDefinitions[key], false)
                if (item) blocks += item
            })

            return blocks;
            // Original Only Available Blocks
            // this.blocks.map(block => {
            //     let item = this.renderBlock(block)
            //     if(item) blocks += item
            // });
            // return blocks;

        },

        renderBlock(block, available = true) {

            // Displan Unavailable Blocks
            if (available !== true) {

                return `<a href="#" class="block -unavailable" style="opacity:0.25;">
                        <span class="icon"><img src="${block.layout}" /></span>
                        <span class="text">
                            <span class="title">
                                <span class="title-icon"><img src="${block.icon}" /></span>
                                <span class="title-text">${block.title}</span>
                            </span>
                            <span class="description">${block.description}</span>
                        </span>
                    </a>`;
            }

            // Display Available Blocks
            if (!this.blockDefinitions[block.rowId]) return null;

            let item = this.blockDefinitions[block.rowId];


            return `<a href="#" class="block" data-layout="${block.rowId}">
                        <span class="icon"><img src="${item.layout}" /></span>
                        <span class="text">
                            <span class="title">
                                <span class="title-icon"><img src="${item.icon}" /></span>
                                <span class="title-text">${item.title}</span>
                            </span>
                            <span class="description">${item.description}</span>
                        </span>
                    </a>`;

        },

        open(e) {
            if (e) e.preventDefault();
            if (TheChurchCo_PageBuilder.trigger.hasClass('-open')) return;

            TheChurchCo_PageBuilder.onOpen();
            TheChurchCo_PageBuilder.modal.toggleClass('-open');
            TheChurchCo_PageBuilder.trigger.toggleClass('-open');
        },

        toggle(e) {

            if (e) e.preventDefault();

            if (TheChurchCo_PageBuilder.trigger.hasClass('-open')) {
                TheChurchCo_PageBuilder.onClose();
            } else {
                TheChurchCo_PageBuilder.onOpen();
            }

            TheChurchCo_PageBuilder.modal.toggleClass('-open');
            TheChurchCo_PageBuilder.trigger.toggleClass('-open');

        },

        onOpen() {

        },

        onClose() {

        }



    };


    module.exports = TheChurchCo_PageBuilder;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/page-builder.js","/modules")